import { createBidOptions } from './create-bid-options';

export const DOUBLE = 'DOUBLE';

export const getOptions = function getOptions() {
  return createBidOptions([ DOUBLE ]);
};
